/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useHistory } from 'react-router-dom';

import { VisitPaymentVisitDetails } from './VisitPaymentVisitDetails';
import { VisitPaymentServiceDetails } from './VisitPaymentServiceDetails';

const VisitPaymentDetails = () => {
  const history = useHistory();
  const visit = history.location.state?.visit;

  const visitServices = visit?.services || []; // your DTO uses: services

  return (
    <>
      {/* Main visit info card */}
      <VisitPaymentVisitDetails visitDetails={visit} />

      {/* Services */}
      <div className="mt-3 space-y-3">
        {visitServices.map((service) => (
          <VisitPaymentServiceDetails
            key={service.registrationServiceId}
            service={service}
          />
        ))}
      </div>
    </>
  );
};

export default VisitPaymentDetails;
